import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { ListingCard } from '../../components';
import css from './SearchResultsPanel.css';
import { handleListingCardClick } from '../ListingCard/helpers';
import { getSecondaryFilters } from '../../containers/SearchPage/SearchPage.helpers';
import { useIntl } from 'react-intl';

// Panel width relative to the viewport
const panelMediumWidth = 50;
const panelLargeWidth = 62.5;
const cardRenderSizes = [
    '(max-width: 767px) 100vw',
    `(max-width: 1023px) ${panelMediumWidth}vw`,
    `(max-width: 1920px) ${panelLargeWidth / 2}vw`,
    `${panelLargeWidth / 3}vw`,
].join(', ');

const SRPListingCard = ({
    listing,
    activeListingId,
    onSettingActiveListingId,
    onSettingListingScores,
    urlQueryParams,
}) => {
    const history = useHistory();
    const intl = useIntl();

    const { uuid } = listing.id;
    const isActive = activeListingId === uuid;

    const [triggered, setTriggered] = useState(false);

    useEffect(() => {
        const containerRef = document.getElementById(`ListingCard-${uuid}`);

        const callback = entries => {
            entries.forEach(entry => {
                const { isIntersecting } = entry;

                if (triggered) {
                    observer.unobserve(containerRef);
                }

                if (isIntersecting) {
                    setTriggered(true);
                }
            });
        };

        const observer = new IntersectionObserver(callback, {
            threshold: [0.45],
        });

        if (containerRef) {
            observer.observe(containerRef);
        }

        return () => {
            if (containerRef) {
                observer.unobserve(containerRef);
            }
        };
    }, []);

    const handleListingCardClickDecorator = e => {
        const allowedFilters = getSecondaryFilters(intl);

        return handleListingCardClick(e, {
            currentListing: listing,
            history: history,
            searchParams: Object.entries(urlQueryParams).reduce((acc, [key, value]) => {
                if (allowedFilters.some(allowedFilterKey => allowedFilterKey === key)) {
                    acc[key] = value;
                }
                return acc;
            }, {}),
        });
    };

    return (
        <ListingCard
            titleTag="h2"
            key={uuid}
            className={css.listingCard}
            handleListingCardClick={handleListingCardClickDecorator}
            cardWrapperClassName={isActive ? css.activeListing : null}
            listing={listing}
            renderSizes={cardRenderSizes}
            setActiveListing={id => onSettingActiveListingId(id ? id.uuid : null)}
            notifyOnScoreChange={score => onSettingListingScores({ uuid, score })}
            postponed={
                !triggered
                    ? {
                          assets: true,
                          riderListing: false,
                          matching: false,
                      }
                    : {}
            }
        />
    );
};

export default SRPListingCard;
